module.exports = __webpack_public_path__ + "img/Security1.1de6ef7.svg";